import fvAnimation from "./fvAnimation"
export default class fvHeight extends fvAnimation {
    constructor(shape){
        super(shape,"fvHeight");
        //获取高
        this.org = this.orgHeight;
        this.orgHeight = shape.height;
        this.orgY = shape.y;
        this.sizeFunction = AsyncFunction("return " + this.expression);
        this.MaxPerc = AsyncFunction("return " + this.MaxPerc);
        this.MinPerc = AsyncFunction("return " + this.MinPerc);
    }
    async run(canvas,value){
        //if(value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        var MaxPercValue = await this.executionScript(this.MaxPerc);
        var MinPercValue = await this.executionScript(this.MinPerc);
        if(this.MaxValue == this.MinValue) return;
        if(size == -9999) return;
        if(this.shape.fctype.indexOf('Obj') >= 0){
            //实际高度/最大高度/事实值*最大百分比
            this.shape.height=(this.orgHeight/(MaxPercValue - MinPercValue)*(size - this.MinValue))*((this.MaxValue - this.MinValue)/100);
            if(this.shape.height>this.orgHeight){
                this.shape.height=this.orgHeight;
                if(this.shape.height <0){
                    this.shape.height=0; 
                }
            }
            switch(parseInt(this.org)){
                case 0:
                    break;
                case 50:
                    this.shape.y = this.orgY + (this.orgHeight-this.shape.height)/2;
                    break;
                case 100:
                    this.shape.y = this.orgY + this.orgHeight - this.shape.height;
                    break;
                default:
                    break;
            }
        }else{
            //位图的动画
            canvas.domStyle.height=(parseFloat(canvas.picHeight)/(MaxPercValue - MinPercValue)*(size - this.MinValue))*((this.MaxValue - this.MinValue)/100)+"px";
            canvas.picStyle.height = (parseFloat(canvas.picHeight)/(MaxPercValue - MinPercValue)*(size - this.MinValue))*((this.MaxValue - this.MinValue)/100)+"px";
            if(parseFloat(canvas.picStyle.height)>parseFloat(canvas.picHeight)){
                canvas.domStyle.height=parseFloat(canvas.picHeight)+"px";
                canvas.picStyle.height=parseFloat(canvas.picHeight)+"px";
                if(parseFloat(canvas.picStyle.height) <0){
                    canvas.domStyle.height="0px"; 
                    canvas.picStyle.height="0px"; 
                }
            }
            switch(parseInt(this.org)){
                case 0:
                    break;
                case 50:
                    canvas.domStyle.top = this.orgY + (parseFloat(canvas.picHeight) - parseFloat(canvas.picStyle.height)) / 2+"px";
                    break;
                case 100:
                    canvas.domStyle.top= this.orgY + parseFloat(canvas.picHeight) - parseFloat(canvas.picStyle.height)+"px";
                    break;
                default:
                    break;
            }
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvHeight.js